module.exports = __webpack_public_path__ + "static/img/gc_tb7_1.4f550d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/hardWare/gc/gc_tb7_1.png
// module id = AIBJ
// module chunks = 0